import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography } from '@mui/material';

const HotelDetailsPage = () => {
  const { id } = useParams();

  return (
    <Container>
      <Typography variant="h4">Hotel Details</Typography>
      <Typography>Hotel ID: {id}</Typography>
    </Container>
  );
};

export default HotelDetailsPage;

